import {Input} from "reactstrap";
import {I18n} from "../../../I18n/components/promoter";
import React from "react";

const PromoterSectionSelect = props => {
    const allOption = !props.required
        ? <option value="">{I18n[props.lang].all}</option>
        : null;
    const options = props.sections
        ? props.sections
            .filter(section => {
                if (!props.companyIdFilter) return true;
                const category = props.categories.find(category => category.id === section.categoryId);
                return category.companyId == props.companyIdFilter
            })
            .filter(section => !props.categoryIdFilter || section.categoryId == props.categoryIdFilter)
            .map((section, i) => <option value={section.id} key={i}>{section.name}</option>)
        : null;
    return (
        <Input
            className="mr-1 mb-1"
            type="select"
            name="sectionId"
            id="sectionId"
            onChange={props.onSectionChange}
            value={props.sectionId}
            required={props.required}
        >
            <option value="">{I18n[props.lang].section}</option>
            {allOption}
            {options}
        </Input>);
}

export default PromoterSectionSelect


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterSection/PromoterSectionSelect.js